import { Button, CHECKBOX_COLUMN_ID } from "@tfg/ui"
import { isEqual } from "lodash"
import { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

import { removeUndefined } from "@tfg/types/schemas/utils"

import { useHeaderControlsContext } from "~/components/contexts/useHeaderControlsContext"
import { AddAndUpdateViewModal } from "~/components/table/views/modals/AddAndUpdateViewModal"

export const TABLE_CONTEXT_MAP = {
  AGEC: "agec",
  LCA: "lca",
  BUSINESS_PARTNERS_REPOSITORY: "businessPartnersRepository",
  BUSINESS_PARTNERS_PRODUCTION_SITES: "businessPartnersProductionSites",
  CERTIFICATES_ALL: "certificatesAll",
  CERTIFICATES_SCOPE: "certificatesScope",
  CERTIFICATES_TRANSACTION: "certificatesTransaction",
  DATA_TRANSFER_IMPORT: "dataHubImport",
  PRODUCTS_CATALOG: "productsCatalog",
  PRODUCTS_CUSTOM_FIELDS: "customFields",
  PRODUCTS_CERTIFICATES: "certificates",
  PRODUCTS_TRACEABILITY: "traceability",
  SUPPLIERS: "suppliers",
  SUB_SUPPLIERS: "subSuppliers",
} as const

export const ViewHeader = ({ tableContext }: { tableContext: string }) => {
  const { t } = useTranslation("common")
  const [opened, setOpened] = useState(false)

  const {
    view,
    columnPinning,
    columnVisibility,
    orderedColumns,
    filters,
    sorts,
    initialColumnPinning,
    initialColumnOrder,
    reset,
  } = useHeaderControlsContext()

  const displayResetButton = useMemo(() => {
    const filtersFetched = view?.filters ?? {}
    const sortsFetched = view?.sorts ?? {}
    const pinnedColumnsFetched = view?.pinnedColumns ?? {
      columnOrder: initialColumnOrder ?? [],
      columnPinning: {
        left: [CHECKBOX_COLUMN_ID, ...(initialColumnPinning?.left ?? [])],
        right: initialColumnPinning?.right ?? [],
      },
    }

    const headerControlsNotMatching =
      !isEqual(filtersFetched, filters) ||
      !isEqual(sortsFetched, sorts) ||
      !isEqual(
        pinnedColumnsFetched,
        removeUndefined({
          columnOrder: orderedColumns,
          columnPinning,
          columnVisibility:
            Object.keys(columnVisibility ?? {}).length > 0
              ? columnVisibility
              : undefined,
        })
      )
    return headerControlsNotMatching
  }, [
    view,
    filters,
    sorts,
    columnPinning,
    columnVisibility,
    orderedColumns,
    initialColumnPinning,
    initialColumnOrder,
  ])

  return (
    <>
      <Button onClick={() => setOpened(true)} variant="ghost">
        {t("table.views.modal.save")}
      </Button>
      {displayResetButton && (
        <Button onClick={reset} variant="ghost">
          {t("table.views.modal.reset")}
        </Button>
      )}
      <AddAndUpdateViewModal
        opened={opened}
        onClose={() => setOpened(false)}
        tableContext={tableContext}
      />
    </>
  )
}
